import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface HotButtonCard {
  id: string;
  title: string;
  suggestion: string;
  why: string;
  quote: string;
  topicKey: string;
  priority: number;
  evidenceTurnIndex: number;
  createdAt: string;
  customerId?: string | null;
  customerName?: string | null;
}

export interface HotButtonState {
  cards: HotButtonCard[];
  addedCardId?: string;
  /** The checklist service says hot buttons are on (HOT_BUTTONS_ENABLED). Off
   *  until a frame says otherwise; while off the pane is not shown. */
  enabled?: boolean;
}

const hotButtonSlice = createSlice({
  name: 'hotButton',
  initialState: {
    cards: [] as HotButtonCard[],
    addedCardId: undefined as string | undefined,
    enabled: false,
  },
  reducers: {
    setHotButton: (state, action: PayloadAction<HotButtonCard | HotButtonState | null>) => {
      const payload = action.payload;
      if (!payload) {
        state.cards = [];
        state.addedCardId = undefined;
        state.enabled = false;
      } else if ('cards' in payload) {
        state.cards = payload.cards;
        state.addedCardId = payload.addedCardId;
        state.enabled = payload.enabled === true;
      } else {
        state.cards = [payload];
        state.addedCardId = payload.id;
      }
    },
  },
});

export const { setHotButton } = hotButtonSlice.actions;
export default hotButtonSlice.reducer;
